import ENUM from '../ENUM'

export default {
    kind: 'QuestionSlide',
    filters: [
        {
            name: ENUM().comparisonSurveyIds,
        },
    ],
    references: [ENUM().pageQuestionId],
}
